{
  "fr": {
    "fleetDashboard": {
      "unnamed": "Sans titre",
      "formats": {
        "weekday": "EEE",
        "day": "d"
      },
      "activity": {
        "title": "Dernières nouvelles",
        "you": "Vous",
        "kinds": {
          "member_joined": "A rejoint la flotte",
          "event_published": "Événement publié",
          "event_cancelled": "Événement annulé",
          "contract_published": "Contrat publié",
          "contract_claimed": "Contrat pris en charge",
          "contract_fulfilled": "Contrat rempli",
          "inventory_transfer_completed": "Transfert terminé",
          "inventory_item_deposited": "Déposé",
          "inventory_item_withdrawn": "Retiré"
        },
        "empty": {
          "title": "Rien ne s'est encore passé",
          "hint": "Les événements et contrats publiés arrivent ici, les plus récents en premier."
        }
      },
      "events": {
        "title": "Événements à venir",
        "signUp": "S'inscrire",
        "empty": {
          "title": "Rien de prévu pour les deux prochaines semaines",
          "hint": "Consultez la page des événements pour la suite.",
          "hintCreate": "Ajoutez une opération au calendrier et les membres pourront s'inscrire tout de suite.",
          "action": "Planifier un événement"
        }
      },
      "actionQueue": {
        "title": "Demande votre attention",
        "joinRequests": {
          "one": "%{count} demande d'adhésion",
          "other": "%{count} demandes d'adhésion"
        },
        "pendingTransfers": {
          "one": "%{count} transfert entrant à traiter",
          "other": "%{count} transferts entrants à traiter"
        },
        "partFailed": "Une partie de ce qui vous attend n'a pas pu être chargée pour le moment.",
        "empty": {
          "title": "Tout est à jour",
          "hint": "Les demandes d'adhésion et les transferts entrants qui attendent une réponse apparaissent ici."
        },
        "memberHealth": {
          "one": "%{count} vérification de l'effectif demande de l'attention",
          "other": "%{count} vérifications de l'effectif demandent de l'attention"
        }
      },
      "contracts": {
        "title": "Contrats",
        "mine": "Votre travail",
        "open": "Disponibles",
        "partFailed": "Certains contrats n'ont pas pu être chargés pour le moment.",
        "empty": {
          "title": "Aucun contrat ouvert",
          "hint": "Parcourez les travaux passés sur le tableau des contrats.",
          "hintCreate": "Publiez une mission que les membres pourront prendre en charge.",
          "action": "Publier un contrat"
        }
      },
      "inventory": {
        "title": "Inventaire",
        "empty": "Aucun mouvement d'inventaire récemment.",
        "emptyMine": "Rien de ce qui vous concerne n'a bougé récemment.",
        "emptyHint": "Les dépôts, retraits et transferts apparaissent ici.",
        "mine": "Les miens",
        "fleet": "Flotte"
      },
      "newMembers": {
        "title": "Nouveaux membres",
        "empty": {
          "title": "Personne de nouveau récemment",
          "hint": "Les membres apparaissent ici dès qu'ils ont rejoint la flotte."
        }
      },
      "about": {
        "title": "À propos de la flotte",
        "empty": {
          "title": "Pas encore de description",
          "hint": "La flotte ne s'est pas encore présentée.",
          "hintEdit": "Dites aux nouveaux membres de quoi parle la flotte.",
          "action": "En rédiger une"
        }
      },
      "week": {
        "emptyDay": "Rien de prévu le %{day}."
      },
      "online": {
        "title": "En ligne (%{count})",
        "titlePending": "En ligne",
        "friend": "Ami",
        "more": {
          "one": "et %{count} autre",
          "other": "et %{count} autres"
        },
        "empty": {
          "title": "Personne d'autre n'est en ligne",
          "hint": "Les membres apparaissent ici dès qu'ils se connectent."
        }
      },
      "announcements": {
        "post": "Publier une annonce",
        "postAction": "Publier",
        "edit": "Modifier l'annonce",
        "body": "Annonce",
        "until": "jusqu'au %{date}",
        "confirmRemove": "Supprimer cette annonce pour tout le monde ?",
        "expiry": {
          "label": "L'afficher",
          "keep": "Garder la fin actuelle",
          "never": "Jusqu'à sa suppression",
          "day": "Un jour",
          "days3": "Trois jours",
          "week": "Une semaine",
          "weeks2": "Deux semaines"
        },
        "messages": {
          "saved": "Annonce enregistrée.",
          "saveFailed": "L'annonce n'a pas pu être enregistrée.",
          "removed": "Annonce supprimée.",
          "removeFailed": "L'annonce n'a pas pu être supprimée."
        },
        "more": {
          "one": "Afficher %{count} autre annonce",
          "other": "Afficher %{count} autres annonces"
        }
      }
    }
  }
}
